import { DataConnection, GetDataConnectionChannel } from '@tableau/search-microview-communication-channels';

import { DataConnections } from '~src/connectivity/resources/DataConnections';
import { FileConnectionDetailInfo, RemoteConnectionDetailInfo, TableauServerConnectionDetailInfo, TableauServerSiteConnectionDetailInfo } from '~src/ts/models/ConnectionDetailInfo';

export function startListening(): () => void {
    const getDataConnectionChannel = new GetDataConnectionChannel();
    const stopListeningToGetDataConnectionChannel = getDataConnectionChannel.listen(request => {
        return new Promise<DataConnection[]>((resolve, reject) => {
            DataConnections.getFromDatasourceByIds(request.dataSourceIds).then(connections => {
                resolve(connections.map<DataConnection>(item => {
                    const tableauServerConnectionDetailInfo=item.connectionDetails as TableauServerConnectionDetailInfo;
                    const remoteConnectionDetailInfo=item.connectionDetails as RemoteConnectionDetailInfo;
                    const tableauServerSiteConnectionDetailInfo=item.connectionDetails as TableauServerSiteConnectionDetailInfo;
                    const tileConnectionDetailInfo=item.connectionDetails as FileConnectionDetailInfo;
                    return {
                        name: tableauServerConnectionDetailInfo.name,
                        dataConnectionsCount: 0,
                        databaseUsername: remoteConnectionDetailInfo.databaseUsername,
                        type: item.connectionDetails.type,
                        serverName: remoteConnectionDetailInfo.serverName,
                        siteUrl: tableauServerSiteConnectionDetailInfo.siteUrl,
                        connectionTypeDisplayName: item.connectionTypeDisplayName,
                        publishedDatasourceDetailsHasExtracts:false,
                        hasEmbeddedPassword: item.connectionDetails.hasEmbeddedPassword,
                        fileName: tileConnectionDetailInfo.fileName,
                    };
                }));
            })
            .catch(error => reject(error));
        });
    });

    return () => {
        stopListeningToGetDataConnectionChannel();
    };
}
